import { render } from "./DialogConfirmJsonpathDeletion.vue?vue&type=template&id=55dfe1fc"
import script from "./DialogConfirmJsonpathDeletion.vue?vue&type=script&lang=js"
export * from "./DialogConfirmJsonpathDeletion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__